import React from 'react';
import { Card } from 'react-bootstrap';
import projImg4 from "../../assets/img/n4.png";
import projectimage4 from "../../assets/img/np4.png";
import ShowMoreText from "react-show-more-text";

const Card4 = () => {
    // Your component logic here

    return (
        <Card className="CARD2" bg="dark">
        {/* <Card.Title><h2>Network analysis of a corpus of laws</h2></Card.Title> */}

        <Card.Img variant="top" src={projectimage4} />

        <Card.Body>
          <Card.Text>
            {" "}
            <img className="img2" src={projImg4} />{" "}
            <p className="text7">Johannes Wachs</p>
            <br />
            <p className="text8">
              Associate Professor <br /> Corvinus University
            </p>
            <p className="text8">
              Senior Researcher <br /> Centre for Economic and Regional
              Studies
            </p>
          </Card.Text>
          <ShowMoreText lines={1}>
            <div>
              Even though Open Source Software (OSS) is used everywhere in
              the modern digital economy, we know surprisingly little
              about where successful libraries come from. In theory anyone
              with an internet connection can create or contribute to OSS
              projects, but in practice most contributions to OSS come
              from a few places like Silicon Valley, London, or Berlin. To
              understand why, we need to know whether projects are start
              in these hubs, or if their creators tend to move there
              later. The aim of this project is to build and compare
              models to infer the country of origin of new software
              libraries using timeseries data of downloads. A second goal
              will be to map temporal dependencies in the adoption of new
              software libraries across countries. Suggested methods range
              from simple heuristics to modeling timeseries using Hawkes
              Processes, Lasso regression, or Transfer Entropy, and
              comparing results within the framework of Granger Causality.
              <br />
              <br />
              Related literature:{" "}
              <ul>
                <li>
                  Wachs, Johannes, et al. "The geography of open source
                  software: Evidence from GitHub."
                  <span className="text9">
                    {" "}
                    Technological Forecasting and Social Change, 2022.
                  </span>{" "}
                </li>
                <li>
                  Bachmann, Jan "Measuring Temporal Dependencies in Music
                  Listening Behavior across Countries"
                  <span className="text9">
                    {" "}
                    Masters Thesis, RWTH Aachen University, 2020{" "}
                  </span>
                </li>
                <li>
                  Xu, Hongteng, Mehrdad Farajtabar, and Hongyuan Zha.
                  "Learning granger causality for hawkes processes."
                  <span className="text9">
                    International conference on machine learning. PMLR,
                    2016.
                  </span>
                </li>
                <li>
                  Arnold, Andrew, Yan Liu, and Naoki Abe. "Temporal causal
                  modeling with graphical Granger methods."
                  <span className="text9">
                    {" "}
                    Proceedings of the 13th ACM SIGKDD International
                    Conference on Knowledge Discovery and Data Mining.
                    2007.
                  </span>
                </li>
                <li>
                  Ver Steeg, Greg, and Aram Galstyan. "Information
                  transfer in social media."
                  <span className="text9">
                    {" "}
                    Proceedings of the 21st International Conference on
                    the World Wide Web. 2012
                  </span>
                </li>
              </ul>
            </div>
          </ShowMoreText>
        </Card.Body>
      </Card>
    );
};

export default Card4;
